// lib/hooks/use-sort.ts
import { useState } from "react";
var useSort = () => {
  const [sortDirection, setSortDirection] = useState();
  const switchSortDirection = () => {
    setSortDirection(
      sortDirection === void 0 ? "asc" : sortDirection === "asc" ? "desc" : void 0
    );
  };
  return { sortDirection, switchSortDirection };
};

export {
  useSort
};
